import React, {PureComponent} from 'react';
import NativeSelect from '@mui/material/NativeSelect';

export class SectionalFilter extends PureComponent{
    state = {
        data : [],
        seccional: 0
    }
    API_URL = "/sectionalFilter";
    componentDidMount() {
        fetch(this.API_URL)
            .then((res) => res.json())
            .then((data1) => {
                this.setState(() => ({
                    data: data1
                }))
            });
    }
    handleChange(e) {
        console.log(e.target.value);
        this.setState({
            seccional: e.target.value
        });
    }

    render() {
        return(
            <div name="sectionalFilter">
                <h5>Seccionales
                    <NativeSelect style={{width: '50%', padding: '2px', marginTop: '2px', marginLeft: '10px'}}
                                  defaultValue={1}
                                  onChange={e => this.props.handleChangesectional(e)}
                                  inputProps={{
                                      name: 'seccional',
                                      id: 'uncontrolled-native',
                                  }}>
                        {this.state.data.map(item => <option key={item.seccional}>{item.seccional}</option>)}
                    </NativeSelect>
                </h5>
            </div>
        )
    }
}